import { AddIcon, TextButton } from '@maersktankersdigital/web-components'
import { Box } from '@mui/material'
import { useState } from 'react'
import { DragAndDropFiles } from './drag-and-drop-files'

export function AddFiles({
  onChangeHandler,
}: {
  onChangeHandler: (files: File[]) => void
}) {
  const [isEditing, setIsEditing] = useState(false)
  return (
    <>
      <Box
        component={TextButton}
        onClick={() => setIsEditing(!isEditing)}
        icon={<AddIcon width="16px" height="16px" />}
        sx={{ pl: 0 }}
      >
        {isEditing ? 'Cancel adding file' : 'Add file'}
      </Box>
      {isEditing && <DragAndDropFiles onChangeHandler={onChangeHandler} />}
    </>
  )
}
